import Seo from "@/components/Seo";
import { Eyebrow, Reveal, Section } from "@/components/Primitives";
import { CaseCard, CtaBanner } from "@/components/Blocks";
import { CLIENTS } from "@/lib/data";

export default function Work() {
    const featured = CLIENTS.filter((c) => c.featured);
    const rest = CLIENTS.filter((c) => !c.featured);
    return (
        <>
            <Seo
                title="Work"
                description="AI and conversational automation case studies — led by GCC delivery for Eagle Hills (Abu Dhabi) and Qatar Post, alongside enterprise work in healthcare, HR, retail, FMCG, and fintech."
                path="/work"
            />

            <Section className="pt-16 md:pt-24 pb-8">
                <Reveal>
                    <Eyebrow>Selected work</Eyebrow>
                    <h1 className="mt-6 font-display font-black tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[1.05] max-w-3xl">
                        Systems shipped into live enterprise environments
                    </h1>
                    <p className="mt-6 text-lg text-pa-ink-500 max-w-2xl">
                        Regional delivery experience with named GCC clients —
                        alongside enterprise work across India and beyond.
                    </p>
                </Reveal>
            </Section>

            {/* GCC proof above the fold */}
            <Section className="pt-0">
                <Reveal>
                    <div className="flex items-center gap-2 font-mono text-xs uppercase tracking-widest text-pa-blue-700 mb-6">
                        <span className="step-tick" aria-hidden="true" />
                        GCC delivery
                    </div>
                </Reveal>
                <div className="grid gap-4 md:grid-cols-2">
                    {featured.map((c, i) => (
                        <CaseCard key={c.id} c={c} index={i} />
                    ))}
                </div>
            </Section>

            <Section className="pt-0">
                <Reveal>
                    <div className="flex items-center gap-2 font-mono text-xs uppercase tracking-widest text-pa-ink-500 mb-6">
                        <span className="step-tick" aria-hidden="true" />
                        More deployments
                    </div>
                </Reveal>
                <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
                    {rest.map((c, i) => (
                        <CaseCard key={c.id} c={c} index={i} />
                    ))}
                </div>
            </Section>

            <CtaBanner />
        </>
    );
}
